import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { PROVIDER_TYPE_ENUM } from 'modules/inventory/provider/common/constants';
import { SOURCE_METRIC_OPTIONS } from './auto-adjustment-rule.source-metrics';

export const sourceMetricFilter: Filter = {
  filter: 'auto-adjustment-rules:fields.sourceMetric',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'sourceMetric',
  field: 'sourceMetric',
  options: SOURCE_METRIC_OPTIONS.map((opt) => ({
    value: opt.value,
    translate: true,
    label: opt.label,
  })),
};

export const fromProviderTypeFilter: Filter = {
  filter: 'auto-adjustment-rules:fields.fromProviderType',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'fromProviderType',
  field: 'fromProvider.type',
  options: [
    {
      value: PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER}`,
    },
    {
      value: PROVIDER_TYPE_ENUM.LOGISTIC,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.LOGISTIC}`,
    },
    {
      value: PROVIDER_TYPE_ENUM.WAREHOUSE,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.WAREHOUSE}`,
    },
  ],
};

export const toProviderTypeFilter: Filter = {
  filter: 'auto-adjustment-rules:fields.toProviderType',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'toProviderType',
  field: 'toProvider.type',
  options: [
    {
      value: PROVIDER_TYPE_ENUM.SUPPLIER,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.SUPPLIER}`,
    },
    {
      value: PROVIDER_TYPE_ENUM.LOGISTIC,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.LOGISTIC}`,
    },
    {
      value: PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER}`,
    },
    {
      value: PROVIDER_TYPE_ENUM.WAREHOUSE,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.WAREHOUSE}`,
    },
    {
      value: PROVIDER_TYPE_ENUM.CARRIER,
      translate: true,
      label: `auto-adjustment-rules:providerType.${PROVIDER_TYPE_ENUM.CARRIER}`,
    },
  ],
};

export const activeStatusFilter: Filter = {
  filter: 'auto-adjustment-rules:fields.active',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'active',
  field: 'active',
  options: [
    { value: 'true', translate: true, label: 'auto-adjustment-rules:status.ACTIVE' },
    { value: 'false', translate: true, label: 'auto-adjustment-rules:status.INACTIVE' },
  ],
};

export const autoAdjustmentRuleFilters = [
  sourceMetricFilter,
  fromProviderTypeFilter,
  toProviderTypeFilter,
  activeStatusFilter,
];
